module.exports = __webpack_public_path__ + "img/宣传_212.19300edd.jpg";